<ion-content *ngIf="geladen" #content class="section-content auftragstyp-kommissionierung" [class.schreibgeschuetzt]="auftragdetails?.isReadOnly">

  <div *ngIf="auftragdetails?.isSchreibgeschuetztAnzeigen" class="archiv-message">Schreibgeschützt<span *ngIf="auftragdetails?.schreibschutzGrund"> – {{ auftragdetails.schreibschutzGrund }}</span></div>

  <div class="section">
    <h1 class="kommissionieren-palette-titel" *ngIf="!oberauftrag">{{ auftrag.DetailInfo1 }}</h1>
    <h1 class="kommissionieren-palette-titel" *ngIf="oberauftrag"><span *ngIf="oberauftrag">{{ oberauftrag.DetailInfo1 }} - </span>{{ auftrag.label }}</h1>

    <div class="adresse">
      <div class="info-texte">
        <div *ngIf="oberauftrag">
          <div *ngIf="oberauftrag.DetailInfo2" class="info2 kommissionieren-oberauftrag-detail2"><span>{{ oberauftrag.DetailInfo2 }}</span></div>
        </div>

        <div *ngIf="auftrag.DetailInfo2" class="info2"><span>{{ auftrag.DetailInfo2 }}</span></div>
      </div>
    </div>

    <div class="section buttons-section buttons-section-top">
      <ng-template ngFor let-b [ngForOf]="buttons">
        <ion-button *ngIf="istStatusuebergangErlaubt(b.workflowStatus)" appClick (clicked)="onButtonClicked(b)" expand="full" [color]="b.color" class="status-button">
          <ion-icon *ngIf="b.icon" slot="start" [name]="b.icon"></ion-icon>
          {{ b.text }}
        </ion-button>
      </ng-template>
    </div>
  </div>

  <div *ngFor="let c of formularKonfiguration.komponenten">
    <div [ngSwitch]="c.name">
      <!-- Fahrzeug-Kennzeichen -->
      <fahrzeug-kennzeichen-komponente *ngSwitchCase="'Fahrzeug-Kennzeichen'" [auftragdetails]="auftragdetails" [komponente]="c"></fahrzeug-kennzeichen-komponente>

      <!-- Abholadresse -->
      <auftrag-adresse-komponente *ngSwitchCase="'Abholadresse'" [auftragdetails]="auftragdetails" [komponente]="c" [adresse]="auftrag.Abholadresse"></auftrag-adresse-komponente>

      <!-- Zweite Abholstelle. Wird nur angezeigt, wenn sie vom ERP gefüllt wurde -->
      <auftrag-adresse-komponente *ngSwitchCase="'Abholadresse2'" [auftragdetails]="auftragdetails" [komponente]="c" [adresse]="auftrag.Abholadresse2"></auftrag-adresse-komponente>

      <!-- Erzeugeradresse -->
      <auftrag-adresse-komponente *ngSwitchCase="'Erzeugeradresse'" [auftragdetails]="auftragdetails" [komponente]="c" [adresse]="auftrag.Erzeugeradresse"></auftrag-adresse-komponente>

      <!-- Verwerteradresse -->
      <auftrag-adresse-komponente *ngSwitchCase="'Verwerteradresse'" [auftragdetails]="auftragdetails" [komponente]="c" [adresse]="auftrag.Verwerteradresse"></auftrag-adresse-komponente>

      <!-- Barcode -->
      <auftrag-barcode-komponente *ngSwitchCase="'Barcode'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-barcode-komponente>

      <!-- Lieferung -->
      <auftrag-lieferung-komponente *ngSwitchCase="'Lieferung'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-lieferung-komponente>

      <!-- Leergut -->
      <auftrag-leergut-komponente *ngSwitchCase="'Leergut'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-leergut-komponente>

      <!-- Unterauftraege -->
      <div *ngSwitchCase="'Unterauftraege'">
        <div *ngIf="unterauftraege.length">
          <div class="section ion-activatable section-unterauftraege">
            <h1>{{ getEinstellung(c, 'Titel', 'Positionen') }}</h1>
            <div class="unterauftraege">
              <app-auftrag-unterauftraege [auftrag]="auftrag" [unterauftraege]="unterauftraege"></app-auftrag-unterauftraege>
            </div>
          </div>
        </div>
      </div>

      <!-- Hinweistexte -->
      <auftrag-hinweistexte-komponente *ngSwitchCase="'Hinweistexte'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-hinweistexte-komponente>

      <!-- Auftragsbilder -->
      <auftrag-bilder-komponente *ngSwitchCase="'Bilder'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-bilder-komponente>

      <!-- Bilder (Kommissionierung) -->
      <auftrag-bilder2-komponente *ngSwitchCase="'Bilder2'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-bilder2-komponente>

      <!-- Anmerkungen-->
      <auftrag-anmerkungen-komponente *ngSwitchCase="'Anmerkungen'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-anmerkungen-komponente>

      <!-- Ext. Auftragsnummer-->
      <auftrag-ext-nummer-komponente *ngSwitchCase="'Ext-Nummer'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-ext-nummer-komponente>

      <!-- Unterschrift -->
      <auftrag-unterschrift-komponente *ngSwitchCase="'Unterschrift'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-unterschrift-komponente>

      <!-- Statusmeldung -->
      <auftrag-statusmeldungen-komponente *ngSwitchCase="'Statusmeldungen'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-statusmeldungen-komponente>

      <!-- Checkliste -->
      <auftrag-checkliste-komponente *ngSwitchCase="'Checkliste'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-checkliste-komponente>

      <!-- Dateien -->
      <auftrag-dateien-komponente *ngSwitchCase="'Dateien'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-dateien-komponente>

      <!-- Buttons -->
      <auftrag-buttons-komponente *ngSwitchCase="'Buttons'" [auftragdetails]="auftragdetails" [komponente]="c"></auftrag-buttons-komponente>

    </div>
  </div>

  <div class="section buttons-section buttons-section-normal" *ngIf="testButtonsAnzeigen">
    <h1>Simulation Barcodes</h1>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '0204069300007016100XX0000')" expand="full" color="light" class="status-button">
      Kohlensäure kurz 10 kg UN 1013
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '0204018715060116100XX0000')" expand="full" color="light" class="status-button">
      Sinalco GS1
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '0200000040693071100XX0000')" expand="full" color="light" class="status-button">
      Distelhäuser Pils 0,33l GS1
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '0200000040693019100XX0000')" expand="full" color="light" class="status-button">
      Distelhäuser Pils 0,5l GS1 40693019
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '0200000040693132100XX0000')" expand="full" color="light" class="status-button">
      Distelhäuser Märzen Urstoff 0,5l GS1
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '0200000040693842100XX0000')" expand="full" color="light" class="status-button">
      Distelhäuser Radler 0,5l GS1
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('LABEL-TYPE-DATAMATRIX', '0200000040693019100XX0000736\u001d1022H010112')" expand="full" color="light" class="status-button">
      Test ZEBRA
    </ion-button>
  </div>

  <div class="section buttons-section buttons-section-normal" *ngIf="testButtonsAnzeigen">
    <h1>Simulation NVEs</h1>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '00123456789012345678')" expand="full" color="light" class="status-button">
      NVE 1
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '00340026279217462900')" expand="full" color="light" class="status-button">
      NVE 2
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '00140026279217462900')" expand="full" color="light" class="status-button">
      NVE 3
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '00340000000000000002')" expand="full" color="light" class="status-button">
      NVE 4 (Distelhäuser Pils 0,5l)
    </ion-button>
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '00340000000000000003')" expand="full" color="light" class="status-button">
      NVE, ARTNR: 512
    </ion-button>    
    <ion-button appClick (clicked)="onSimuliereBarcode('GS1-128', '00340000000000000004')" expand="full" color="light" class="status-button">
      NVE, ARTNR: 512 (Nr. 2)
    </ion-button>    
  </div>
  
</ion-content>

<div *ngIf="anzeigeBild" class="anzeigebild">
  <pinch-zoom>
    <img class="bild" [src]="domSanitizationService.bypassSecurityTrustUrl(anzeigeBild.src)" />
  </pinch-zoom>

  <ion-button expand="full" fill="clear" appClick (clicked)="onBildClicked(null)">
    <ion-ripple-effect></ion-ripple-effect>
    <ion-icon name="close"></ion-icon> Schließen
  </ion-button>
</div>